export const MIN_WIDTH = 406;
export const MIN_ROW_HEAD_WIDTH = 180;
